import { render, staticRenderFns } from "./DetectionListRequestHistoryLayout.vue?vue&type=template&id=256d4f04&scoped=true&"
import script from "./DetectionListRequestHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./DetectionListRequestHistoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d4f04",
  null
  
)

export default component.exports